/* Fiveaven (20/10/2026, demande d'Andy) : pas de clic droit, de glisser-déposer ni de téléchargement
   sur les images et vidéos. Dissuasif seulement : une capture d'écran reste possible.
   23/10/2026 (Andy : « on dit pas pouvoir faire clic droit ») : clic droit coupé sur TOUT le site, pas seulement quand le
   clic tombe pile sur une image (un lien ou un calque posé sur la photo laissait « Enregistrer l'image sous… ») ; seuls
   les champs de saisie le gardent (coller une adresse, un code). Ctrl/Cmd + S (enregistrer la page) est aussi neutralisé. */
(function () {
  if (window.Shopify && Shopify.designMode) return;

  var saisie = function (t) {
    return t && t.closest ? t.closest("input, textarea, select, [contenteditable]:not([contenteditable=false])") : null;
  };
  var media = function (t) {
    return t && t.closest ? t.closest("img, picture, video, svg, canvas, a") : null;
  };

  document.addEventListener("contextmenu", function (e) {
    if (!saisie(e.target)) e.preventDefault();
  }, true);
  document.addEventListener("dragstart", function (e) {
    if (media(e.target)) e.preventDefault();
  }, true);
  document.addEventListener("keydown", function (e) {
    if ((e.ctrlKey || e.metaKey) && !e.altKey && (e.key === "s" || e.key === "S")) e.preventDefault();
  }, true);

  var verrouiller = function (racine) {
    var videos = racine.tagName === "VIDEO" ? [racine] : racine.querySelectorAll ? racine.querySelectorAll("video") : [];
    for (var i = 0; i < videos.length; i++) {
      videos[i].setAttribute("controlslist", "nodownload noremoteplayback");
      videos[i].setAttribute("disablepictureinpicture", "");
    }
  };

  verrouiller(document);
  new MutationObserver(function (lots) {
    lots.forEach(function (lot) {
      lot.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) verrouiller(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
